/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/bolmateStatusTile.scss';

import React from 'react';

import classNames from 'classnames';

import {nonBreakingHyphens} from '../../../util/utils';

/** `gray` is the deliberate off / not-yet-known state: nothing is wrong, so it
 *  neither alarms nor congratulates. Only `orange` and `red` ask for attention. */
export type StatusTileState = 'green' | 'gray' | 'orange' | 'red';

interface Props {
    label: string;
    /** Shown instead of `label` once the tiles no longer fit it side by side. */
    compactLabel?: string;
    state: StatusTileState;
    onClick?: () => void;
    className?: string;
}

export default function BolmateStatusTile(props: Props) {
    const {label, compactLabel, state, onClick, className} = props;

    return (
        <button
            type='button'
            className={classNames('bolmate-status-tile', state, !!onClick && 'clickable', className)}
            onClick={onClick}
            // Without a handler the tile is a read-out, not a control: nothing to
            // press, so it also stays out of the tab order.
            disabled={!onClick}
            aria-label={label}
        >
            <span className='status-tile-dot'>
                <span className='status-tile-dot-core' />
            </span>
            <span className='status-tile-label'>
                <span className='status-tile-label-full'>{nonBreakingHyphens(label)}</span>
                {!!compactLabel && (
                    <span className='status-tile-label-compact' aria-hidden='true'>
                        {nonBreakingHyphens(compactLabel)}
                    </span>
                )}
            </span>
        </button>
    );
}
